

enum NoPriceShippingMethods {
    groby = 'GRoby',
    gpoint = 'GPoint',
}

/**
 * The price input should not appear at certain shipping methods, so this function checks if the param code is one of those shipping methods
 */
export const shouldPriceAppear = (code: string | null): boolean => {
    if (code === null) {
        return true;
    }

    let foundException: boolean = false;
    for (const shippingMethod in NoPriceShippingMethods) {
        if (code === NoPriceShippingMethods[shippingMethod]) {
            foundException = true;
        }
    }
    return (foundException) ? false : true;
};



// WEBPACK FOOTER //
// ./src/utils/ShippingMethod.ts